import { render, staticRenderFns } from "./CoursesList.vue?vue&type=template&id=1a838701&scoped=true&"
import script from "./CoursesList.vue?vue&type=script&lang=js&"
export * from "./CoursesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a838701",
  null
  
)

export default component.exports